<div class="page-header">
  <app-page-title></app-page-title>
</div>

<div class="card shadow-sm border-0 mb-4">
  <div class="card-header py-3 bg-white">
    <form class="d-flex align-items-center justify-content-between gap-2 flex-wrap" (ngSubmit)="search()">
      <div class="d-flex align-items-center gap-2 flex-wrap">
        <span class="text-body-secondary small">รายวัน</span>
        <gt-ng-datepicker name="dateStart" size="sm" placeholder="วันที่เริ่มต้น"
                          [ngModel]="dateStart()" (ngModelChange)="dateStart.set($event)"/>
        <span class="text-body-secondary small">ถึง</span>
        <gt-ng-datepicker name="dateEnd" size="sm" placeholder="วันที่สิ้นสุด"
                          [ngModel]="dateEnd()" (ngModelChange)="dateEnd.set($event)"/>
        <button class="btn btn-sm btn-default" type="submit" [disabled]="loading()">
          <i class="bi bi-search me-1"></i>ค้นหา
        </button>
        <button type="button" class="btn btn-sm btn-default" (click)="reset()" [disabled]="loading()">ล้าง</button>
      </div>

      <div class="d-flex align-items-center gap-2">
        <span class="text-body-secondary small">รายเดือน ปี</span>
        <select class="form-select form-select-sm filter-select" name="year"
                [ngModel]="year()" (ngModelChange)="onYearChange($event)">
          @for (y of yearOptions(); track y) {
            <option [ngValue]="y">{{ thaiYear(y) }}</option>
          }
        </select>
      </div>
    </form>
  </div>
</div>

<div class="chart-row mb-4">
  <div class="chart-card">
    <div class="chart-card-header">สถานะการตรวจสอบ <small class="text-body-secondary fw-normal">(ช่วงวันที่ที่เลือก)</small></div>
    <div class="chart-card-body">
      <div class="pie">
        <div class="pie-ring" [style.background]="dailyInspectionBg()"></div>
        <div class="pie-center">
          <span class="pie-value">{{ inspectionTotal() | number }}</span>
          <span class="pie-label">คำขอ</span>
        </div>
      </div>
      <div class="chart-legend">
        <div class="legend-item">
          <span class="legend-dot" style="background: #22c55e"></span>
          <span class="legend-label">ตรวจสอบแล้ว</span>
          <span class="legend-value">{{ dailyTotals().reviewed | number }} ({{ pct(dailyTotals().reviewed, inspectionTotal()) | number:'1.0-0' }}%)</span>
        </div>
        <div class="legend-item">
          <span class="legend-dot" style="background: #f59e0b"></span>
          <span class="legend-label">รอตรวจสอบ</span>
          <span class="legend-value">{{ dailyTotals().pendingReview | number }} ({{ pct(dailyTotals().pendingReview, inspectionTotal()) | number:'1.0-0' }}%)</span>
        </div>
      </div>
    </div>
  </div>

  <div class="chart-card">
    <div class="chart-card-header">สถานะการอนุมัติ <small class="text-body-secondary fw-normal">(ช่วงวันที่ที่เลือก)</small></div>
    <div class="chart-card-body">
      <div class="pie">
        <div class="pie-ring" [style.background]="dailyApprovalBg()"></div>
        <div class="pie-center">
          <span class="pie-value">{{ approvalTotal() | number }}</span>
          <span class="pie-label">คำขอ</span>
        </div>
      </div>
      <div class="chart-legend">
        <div class="legend-item">
          <span class="legend-dot" style="background: #22c55e"></span>
          <span class="legend-label">อนุมัติแล้ว</span>
          <span class="legend-value">{{ dailyTotals().approved | number }} ({{ pct(dailyTotals().approved, approvalTotal()) | number:'1.0-0' }}%)</span>
        </div>
        <div class="legend-item">
          <span class="legend-dot" style="background: #f59e0b"></span>
          <span class="legend-label">รออนุมัติ</span>
          <span class="legend-value">{{ dailyTotals().pendingApproval | number }} ({{ pct(dailyTotals().pendingApproval, approvalTotal()) | number:'1.0-0' }}%)</span>
        </div>
        <div class="legend-item">
          <span class="legend-dot" style="background: #ef4444"></span>
          <span class="legend-label">ไม่ผ่าน</span>
          <span class="legend-value">{{ dailyTotals().rejected | number }} ({{ pct(dailyTotals().rejected, approvalTotal()) | number:'1.0-0' }}%)</span>
        </div>
      </div>
    </div>
  </div>

  <div class="chart-card">
    <div class="chart-card-header">ผ่านตรวจสอบ <small class="text-body-secondary fw-normal">(ปี {{ thaiYear(year()) }})</small></div>
    <div class="chart-card-body">
      <div class="pie">
        <div class="pie-ring" [style.background]="monthlyPassBg()"></div>
        <div class="pie-center">
          <span class="pie-value">{{ monthlyPassPct() | number:'1.0-1' }}%</span>
          <span class="pie-label">ผ่านตรวจสอบ</span>
        </div>
      </div>
      <div class="chart-legend">
        <div class="legend-item">
          <span class="legend-dot" style="background: #3b82f6"></span>
          <span class="legend-label">ผ่าน</span>
          <span class="legend-value">{{ monthlyPassPct() | number:'1.0-1' }}%</span>
        </div>
        <div class="legend-item">
          <span class="legend-dot" style="background: #e5e7eb"></span>
          <span class="legend-label">อื่นๆ</span>
          <span class="legend-value">{{ 100 - monthlyPassPct() | number:'1.0-1' }}%</span>
        </div>
      </div>
    </div>
  </div>

  <div class="chart-card">
    <div class="chart-card-header">อัตราการอนุมัติ <small class="text-body-secondary fw-normal">(ทุกปี)</small></div>
    <div class="chart-card-body">
      <div class="pie">
        <div class="pie-ring" [style.background]="yearlyApprovalBg()"></div>
        <div class="pie-center">
          <span class="pie-value">{{ yearlyApprovalRate() | number:'1.0-1' }}%</span>
          <span class="pie-label">อนุมัติ</span>
        </div>
      </div>
      <div class="chart-legend">
        <div class="legend-item">
          <span class="legend-dot" style="background: #8b5cf6"></span>
          <span class="legend-label">อนุมัติ</span>
          <span class="legend-value">{{ yearlyApprovalRate() | number:'1.0-1' }}%</span>
        </div>
        <div class="legend-item">
          <span class="legend-dot" style="background: #e5e7eb"></span>
          <span class="legend-label">อื่นๆ</span>
          <span class="legend-value">{{ 100 - yearlyApprovalRate() | number:'1.0-1' }}%</span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card shadow-sm border-0 mb-4">
  <div class="card-header py-3 bg-white d-flex align-items-center justify-content-between">
    <h6 class="mb-0 fw-bold">รายงานรายวัน</h6>
    @if (dateStart() && dateEnd()) {
      <span class="text-body-secondary small">{{ thaiDate(dateStart()) }} ถึง {{ thaiDate(dateEnd()) }}</span>
    }
  </div>
  <div class="card-body p-0">
    <div class="table-responsive">
      <table class="table caption-top table-hover mb-0">
        <thead class="bg-light">
          <tr>
            <th nowrap>วันที่</th>
            <th nowrap class="text-end">คำขอทั้งหมด</th>
            <th nowrap class="text-end">ตรวจสอบแล้ว</th>
            <th nowrap class="text-end">รอตรวจสอบ</th>
            <th nowrap class="text-end">รออนุมัติ</th>
            <th nowrap class="text-end">อนุมัติแล้ว</th>
            <th nowrap class="text-end">ไม่ผ่าน</th>
            <th nowrap class="text-end">รหัส e-Coding ที่ออก</th>
          </tr>
        </thead>
        <tbody>
          @for (row of dailyData(); track row.date) {
            <tr>
              <td>{{ thaiDate(row.date) }}</td>
              <td class="text-end">{{ row.totalRequests | number }}</td>
              <td class="text-end">{{ row.reviewed | number }}</td>
              <td class="text-end">{{ row.pendingReview | number }}</td>
              <td class="text-end">{{ row.pendingApproval | number }}</td>
              <td class="text-end">{{ row.approved | number }}</td>
              <td class="text-end">{{ row.rejected | number }}</td>
              <td class="text-end">{{ row.ecodingCodes | number }}</td>
            </tr>
          } @empty {
            <tr>
              <td colspan="8" class="text-center py-4 text-body-secondary">
                {{ loading() ? 'กำลังโหลด...' : '- ไม่มีข้อมูล -' }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="card shadow-sm border-0 mb-4">
  <div class="card-header py-3 bg-white d-flex align-items-center justify-content-between">
    <h6 class="mb-0 fw-bold">รายงานรายเดือน</h6>
    <span class="text-body-secondary small">ปี {{ thaiYear(year()) }}</span>
  </div>
  <div class="card-body p-0">
    <div class="table-responsive">
      <table class="table caption-top table-hover mb-0">
        <thead class="bg-light">
          <tr>
            <th nowrap>เดือน/ปี</th>
            <th nowrap class="text-end">จำนวนคำขอ</th>
            <th nowrap class="text-end">ผ่านตรวจสอบ (%)</th>
            <th nowrap class="text-end">อนุมัติ (%)</th>
            <th nowrap class="text-end">ออกเลขรหัส e-Coding</th>
            <th nowrap class="text-end">ระยะเวลาดำเนินการเฉลี่ย</th>
            <th nowrap class="text-end">คำขอคงค้าง</th>
          </tr>
        </thead>
        <tbody>
          @for (row of monthlyData(); track row.month) {
            <tr>
              <td>{{ thaiMonth(row.month) }}</td>
              <td class="text-end">{{ row.totalRequests | number }}</td>
              <td class="text-end">{{ row.passInspectionPct | number:'1.0-1' }}%</td>
              <td class="text-end">{{ row.approvalPct | number:'1.0-1' }}%</td>
              <td class="text-end">{{ row.ecodingCodes | number }}</td>
              <td class="text-end">{{ duration(row.avgDurationDays) }}</td>
              <td class="text-end">{{ row.pendingRequests | number }}</td>
            </tr>
          } @empty {
            <tr>
              <td colspan="7" class="text-center py-4 text-body-secondary">
                {{ loading() ? 'กำลังโหลด...' : '- ไม่มีข้อมูล -' }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="card shadow-sm border-0 mb-4">
  <div class="card-header py-3 bg-white">
    <h6 class="mb-0 fw-bold">รายงานรายปี</h6>
  </div>
  <div class="card-body p-0">
    <div class="table-responsive">
      <table class="table caption-top table-hover mb-0">
        <thead class="bg-light">
          <tr>
            <th nowrap>ปี</th>
            <th nowrap class="text-end">คำขอทั้งหมด</th>
            <th nowrap class="text-end">อนุมัติทั้งหมด</th>
            <th nowrap class="text-end">รหัส e-Coding ที่กำหนด</th>
            <th nowrap class="text-end">อัตราอนุมัติ</th>
            <th nowrap class="text-end">ระยะเวลาดำเนินการเฉลี่ย</th>
            <th nowrap>แนวโน้ม</th>
          </tr>
        </thead>
        <tbody>
          @for (row of yearlyData(); track row.year) {
            <tr>
              <td>{{ thaiYear(row.year) }}</td>
              <td class="text-end">{{ row.totalRequests | number }}</td>
              <td class="text-end">{{ row.totalApproved | number }}</td>
              <td class="text-end">{{ row.ecodingCodesAssigned | number }}</td>
              <td class="text-end">{{ row.approvalRate | number:'1.0-1' }}%</td>
              <td class="text-end">{{ duration(row.avgDurationDays) }}</td>
              <td>
                @switch (row.trend) {
                  @case ('เพิ่มขึ้น') { <span class="text-success"><i class="bi bi-arrow-up-right me-1"></i>{{ row.trend }}</span> }
                  @case ('ลดลง') { <span class="text-danger"><i class="bi bi-arrow-down-right me-1"></i>{{ row.trend }}</span> }
                  @default { {{ row.trend }} }
                }
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="7" class="text-center py-4 text-body-secondary">
                {{ loading() ? 'กำลังโหลด...' : '- ไม่มีข้อมูล -' }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
